export class ConfigObj {

    method = 'GET'
    url = ''
    headers = ''
    content = {}
    tagDictionary = {
        'GET': 'params',
        'POST': 'data',
        'DELETE': 'params'

    }
    axiosObj = {}

    constructor(method = 'GET', url = '', headers = {}, content = {}) {
        this.method = method
        this.url = url
        this.headers = headers
        this.content = content

        this.getAxiosObj()
    }

    getAxiosObj() {
        const axiosObj = {
            method: this.method,
            url: this.url,
            headers: this.headers
        }
        const newTag = this.getContentTag(this.method)
        axiosObj[newTag] = this.content

        this.axiosObj = axiosObj
    }

    getContentTag(tag) {
        return this.tagDictionary[tag]
    }
}